import { styled } from '@mui/material/styles';

export const Container = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: "12px",
  minWidth: 150,
  padding: 16,

  '> span': {
    display: 'flex',
    flexDirection: 'column',

    '> strong': {
      fontSize: '1.125rem',
    },

    '> p': {
      fontSize: '0.875rem',
      fontWeight: 300,
      margin: 0,
    }
  }
}));
